var config = function (C) {
  C.APP_NAME = "distributor";
  C.userUrl = "/api/distributor/user";

  C.orderRejectReasons = {
    allOutOfStock: false,
    minimumNotMet: false,
    pastOrderCutoffTime: false,
    wrongProductOrdered: false,
    other: false,
  };
  C.orderRejectText = {
    allOutOfStock: "Items are out of stock",
    minimumNotMet: "Order minimum not met",
    pastOrderCutoffTime: "Past order cut off time",
    wrongProductOrdered: "Wrong product ordered",
    other: "Other",
  };
  C.distributorRoles = [
    { id: "distributor_admin", label: "Distributor Admin" },
    { id: "manager", label: "Manager" },
    { id: "sales_rep", label: "Sales Rep" },
    { id: "payments_admin", label: "Payments Admin" },
  ];
  C.containerTypes = [
    { value: "bottle", label: "Bottles" },
    { value: "can", label: "Cans" },
    { value: "keg", label: "Kegs" },
    { value: "other", label: "Other" },
  ];

  C.materials = [
    { id: null, name: "Glass" },
    { id: "plastic", name: "Plastic" },
    { id: "aluminum", name: "Aluminum" },
  ];
  C.daysOfWeek = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
  C.salesforceChatContext = "distributor";

  window.C = C;
};

config.$inject = ["C"];

if (typeof tiz !== "undefined" && tiz.config) {
  tiz.config(config);
}

export default config;
